import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { AdminSidebar } from './AdminSidebar';
import { useAdminSidebar } from './useAdminSidebar';
import { CommandPalette } from '../../features/admin/search/CommandPalette';

/**
 * Admin surface shell — sidebar rail on the left. Publishes its current
 * width via CSS var `--velora-sidebar-width` so ProductShell's top bar and
 * content shift right by the same amount. The toggle button + ⌘K hint live
 * in the ProductShell top bar (there's no second bar here).
 */
export function AdminShell() {
  const { collapsed, width } = useAdminSidebar();

  useEffect(() => {
    document.documentElement.style.setProperty('--velora-sidebar-width', `${width}px`);
    return () => {
      document.documentElement.style.removeProperty('--velora-sidebar-width');
    };
  }, [width]);

  return (
    <>
      <aside
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          bottom: 0,
          width,
          background: '#fbfbfc',
          borderRight: '1px solid #eef0f3',
          zIndex: 1000,
          overflow: 'hidden',
          transition: 'width 0.2s',
        }}
      >
        <AdminSidebar collapsed={collapsed} />
      </aside>
      <div style={{ padding: 22 }}>
        <div style={{ maxWidth: 1320, margin: '0 auto' }}>
          <Outlet />
        </div>
      </div>
      <CommandPalette />
    </>
  );
}
